var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4676 2.39482C15.3088 3.85198 13.776 6.31198 11.0438 7.8894C8.31166 9.46681 5.41481 9.5643 4.57352 8.10715C3.73223 6.64999 5.26509 4.18999 7.99725 2.61258C10.7294 1.03516 13.6263 0.93767 14.4676 2.39482Z",
    fill: "url(#paint0_linear_4493_2956)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04657 10.7417C4.72915 10.7417 6.09315 13.2991 6.09315 16.454C6.09315 19.6088 4.72915 22.1663 3.04657 22.1663C1.364 22.1663 1.37902e-07 19.6088 0 16.454C-1.37902e-07 13.2991 1.364 10.7417 3.04657 10.7417Z",
    fill: "url(#paint1_linear_4493_2956)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57902 24.8142C5.4203 23.3571 8.31716 23.4546 11.0493 25.032C13.7815 26.6094 15.3143 29.0694 14.4731 30.5265C13.6318 31.9837 10.7349 31.8862 8.00275 30.3088C5.27059 28.7314 3.73773 26.2714 4.57902 24.8142Z",
    fill: "url(#paint2_linear_4493_2956)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5324 30.5234C16.6912 29.0662 18.224 26.6062 20.9562 25.0288C23.6883 23.4514 26.5852 23.3539 27.4265 24.811C28.2678 26.2682 26.7349 28.7282 24.0027 30.3056C21.2706 31.883 18.3737 31.9805 17.5324 30.5234Z",
    fill: "url(#paint3_linear_4493_2956)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9534 22.16C27.2709 22.16 25.9069 19.6025 25.9069 16.4476C25.9069 13.2928 27.2709 10.7353 28.9534 10.7353C30.636 10.7353 32 13.2928 32 16.4476C32 19.6025 30.636 22.16 28.9534 22.16Z",
    fill: "url(#paint4_linear_4493_2956)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.421 8.07785C26.5797 9.53501 23.6828 9.43752 20.9507 7.8601C18.2185 6.28269 16.6857 3.82268 17.5269 2.36553C18.3682 0.908377 21.2651 1.00587 23.9973 2.58328C26.7294 4.1607 28.2623 6.6207 27.421 8.07785Z",
    fill: "url(#paint5_linear_4493_2956)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4493_2956",
    x1: 16,
    y1: 1.33337,
    x2: 16,
    y2: 31.5587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C19BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8347E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4493_2956",
    x1: 16,
    y1: 1.33337,
    x2: 16,
    y2: 31.5587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C19BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8347E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4493_2956",
    x1: 16,
    y1: 1.33337,
    x2: 16,
    y2: 31.5587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C19BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8347E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4493_2956",
    x1: 16,
    y1: 1.33337,
    x2: 16,
    y2: 31.5587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C19BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8347E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4493_2956",
    x1: 16,
    y1: 1.33337,
    x2: 16,
    y2: 31.5587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C19BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8347E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4493_2956",
    x1: 16,
    y1: 1.33337,
    x2: 16,
    y2: 31.5587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C19BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8347E5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleLogo);
export default __webpack_public_path__ + "static/media/purpleLogo.5b3e016a11fc5d987167468b99d67039.svg";
export { ForwardRef as ReactComponent };